import React, { useState, useEffect } from "react";
import { endPoints, paymentEndpoints } from "../../constant/Environment";
import {
    fetchAllData,
  getAllData,
  getAllFilterData,
} from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import SearchIcon from "@mui/icons-material/Search";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { Col, Row, Container } from "react-bootstrap";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const CoinFeeListing = () => {
  const [pending, setPending] = useState(true);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  
  // Separate states for search currency table
  const [searchCurrency, setSearchCurrency] = useState([]);
  const [searchPage, setSearchPage] = useState(0);
  const [searchRowsPerPage, setSearchRowsPerPage] = useState(10);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const searchEmptyRows =
    searchPage > 0 ? Math.max(0, (1 + searchPage) * searchRowsPerPage - searchCurrency.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChangePage = (event, newPage) => {
    setSearchPage(newPage);
  };

  const handleSearchChangeRowsPerPage = (event) => {
    setSearchRowsPerPage(parseInt(event.target.value, 10));
    setSearchPage(0);
  };

  useEffect(() => {
    fetchCoinFeeData();
  }, []);

  const fetchCoinFeeData = async () => {
    setIsLoading(true);
    let url = `${paymentEndpoints.apiBaseUrl}${paymentEndpoints.api.GET_COIN_FEE}?amount=1`;
    try{   
        const responseData = await fetchAllData(url);
        const response = await responseData.json();
        if (response?.success) {
          const data = response?.fees;
          setRows(data);
        } else {
          ErrorToast(response.message || "Failed to fetch coin fee data");
        }
    }catch (err) {
        setIsLoading(false);
        console.error("Error fetching coin fee data:", err);
        ErrorToast("Error fetching coin fee data");
      }
      finally {
        setIsLoading(false);  
      };
  };

  const handleSearch = async () => {
    if (!searchText.trim()) {
      ErrorToast("Please enter a currency name to search");
      return;
    }
    setIsSearchLoading(true);
    let url = `${paymentEndpoints.apiBaseUrl}${paymentEndpoints.api.SEARCH_COIN_FEE}?currency=${searchText}&amount=1`;
    try{   
        const responseData = await fetchAllData(url);
        const response = await responseData.json();
        if (response?.success) {
          // const data = response?.data;
          setSearchCurrency([response?.data]);
          setSearchPage(0);
        } else {
          setSearchCurrency([]);
          ErrorToast("No results found for the specified currency");
        }
    }catch (err) {
        setIsSearchLoading(false);
        console.error("Error searching currency:", err);
        setSearchCurrency([]);
      }finally {
        setIsSearchLoading(false);
      };
  };

  const handleCloseSearchModal = () => {
    setShowSearchModal(false);
    setSearchText("");
    setSearchCurrency([]);
  };

  return (
    <>
      <div className="main">
        <Toaster />
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2 heading-table"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    Coin Fee Listing
                  </h3>
                  <div className="d-flex gap-2">
                    <Button
                      variant="primary"
                      onClick={() => setShowSearchModal(true)}
                      className="d-flex align-items-center gap-2 mb-1"
                    >
                      <SearchIcon fontSize="small" />
                      Search Currency
                    </Button>
                  </div>
                </div>
              </div>

              <div style={{ marginTop: "10px" }}>
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        aria-label="a dense table"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">S.No</TableCell>
                            <TableCell align="center">Currency</TableCell>
                            <TableCell align="center">Fee Amount</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.length > 0 ? (
                            (rowsPerPage > 0
                              ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                              : rows
                            ).map((row, index) => (
                              <TableRow
                                key={index}
                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                              >
                                <TableCell align="center">
                                  {page * rowsPerPage + index + 1}
                                </TableCell>
                                <TableCell align="center">{row?.currency || 'N/A'}</TableCell>
                                <TableCell align="center">{row?.fee}</TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={3} align="center">
                                No coin fee data available
                              </TableCell>
                            </TableRow>
                          )}
                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={3} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                              colSpan={3}
                              count={rows.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Search Modal */}
      <Modal show={showSearchModal} onHide={handleCloseSearchModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Search Currency</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="mb-3">
            <Col>
              <TextField
                fullWidth
                label="Search by Currency Name"
                variant="outlined"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleSearch();
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="search"
                        onClick={handleSearch}
                        edge="end"
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Col>
          </Row>

          {/* Search Results Table */}
         {isSearchLoading && <Loader spinner={true} visible={isSearchLoading} />}
            <Row>
              <Col>
                <TableContainer component={Paper}>
                  <Table
                    className="c_table"
                    size="small"
                    aria-label="search results table"
                    stickyHeader
                    sx={{ minWidth: 500 }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">S.No</TableCell>
                        <TableCell align="center">Currency</TableCell>
                        <TableCell align="center">Fee Amount</TableCell>
                      </TableRow>
                    </TableHead>
                   {/* {searchCurrency.length > 0 && ( */}
                    <TableBody>
                      {searchCurrency.length > 0 &&
                      searchCurrency?.map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                        >
                          <TableCell align="center">
                            {index + 1}
                          </TableCell>
                          <TableCell align="center">{row?.currency}</TableCell>
                          <TableCell align="center">{row?.fee}</TableCell>
                        </TableRow>
                      ))}
                      {searchEmptyRows > 0 && (
                        <TableRow style={{ height: 53 * searchEmptyRows }}>
                          <TableCell colSpan={3} />
                        </TableRow>
                      )}
                    </TableBody>
                   {/* )} */}
                  </Table>
                </TableContainer>
              </Col>
            </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseSearchModal}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSearch}>
            Search
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CoinFeeListing;